export const fulfillmentOptions = [
  { label: 'Not started', value: '' },
  { label: 'Packing in Progress', value: 'packing_in_progress' },
  { label: 'Packed', value: 'packed' },
  { label: 'Fulfilled', value: 'fulfilled' },
  { label: 'Return Received', value: 'return_received' },
  { label: 'Checked / Done', value: 'checked_done' },
];

export function fulfillmentValue(rental) {
  return rental.fulfillmentStatus || (
    rental.status === 'returned' ? 'return_received' :
      ['active', 'overdue'].includes(rental.status) ? 'fulfilled' : ''
  );
}

export function fulfillmentLabel(rental) {
  return fulfillmentOptions.find((option) => option.value === fulfillmentValue(rental))?.label || 'Not started';
}
